export interface effectiveDataProps {
    heading: string,
    image: string,
    image_alt: string,
    paragraphs: (string | JSX.Element)[]
}

export interface topImageAndheadingEffectiveDataProps {
    heading: string,
    screenShot: string,
    screenShotAlt: string,
    paraContent: string[]

}


export const effectiveData = [
    {
        heading: "Setting your total budget",
        image: "",
        image_alt:"",
        paragraphs: [
            "Start by determining the total amount of money you are comfortable spending. Consider your finances, income, and savings, along with any contributions from family or friends.",
            "For instance, the average Canadian wedding might cost around $32,000, but this can vary widely based on location, sizes of the wedding, and personal preferences. For example, a small local elopement could have a budget of under $1,500, while a destination wedding in the south of France could be over $200,000.",
            "You're going to hear many opinions from lots of people. Focus on what matters most to you and your partner, then build your budget from there. Either way, establishing your total budget upfront is crucial, as it informs how funds will be allocated across various aspects of the wedding."
        ]
    },
    {
        heading: "Categorizing expenses",
        image: "",
        image_alt:"",
        paragraphs: [
            "After setting your total budget, categorize your expenses in the Budget tab by setting your expected costs. We've done all the hard work of identifying key areas like venue, catering, fashion, flowers, along with many others.",
            "Within these categories, there are a variety of common expenses that are outlined and these typically cover expenses for 95% of weddings. However, you can always customize these categories by changing the title to fit your specific wedding needs allowing for better financial management."
        ]
    },
    {
        heading: "Tracking actual costs",
        image: "",
        image_alt:"",
        paragraphs: [
            "Tracking actual costs as you book services is important to stay within your budget. Regularly updating your budget template with real expenses helps identify overspending areas and allows you to make necessary adjustments to ensure your wedding budget makes sense as you progress throughout wedding planning.",
            "The template will highlight the difference from expected costs and actual costs, while showing the outstanding amount if you're paying the expense in installments like a deposit on a venue. You'll be able to set the due date of when the final payment is due.",
            "If you find yourself overspending in one spot, consider adjusting other categories to stay within your total budget or make the decision to go crazy by adding to your total budget."
        ]
    },
]

export const topImageAndheadingEffectiveData = {
    heading : "How to use a wedding budget template effectively",
    screenShot: "https://cdn.buttercms.com/IUWQsZbOSYiBhhWwTkkL",
    screenShotAlt: "Screenshot from the free wedding budget spreadsheet showing a variety of wedding expenses.",
    paraContent : [
        "Getting your wedding budget planner started is easy! Download the template, set your total budget, then begin to add your expected costs to the expenses and update the actual costs throughout planning.",
        "Once you download the Google Sheets or Excel version of the template, begin in the Home tab by adding your names and budget in the Start Here section. "
    ]
}
